const CODES = [
  { id: "app-store", src: "/qr/app-store.svg", store: "App Store", device: "iPhone and iPad" },
  { id: "google-play", src: "/qr/google-play.svg", store: "Google Play", device: "Android" },
];

export const StoreQRCodes = ({ eyebrow = "Download the app", footer = "Scan with your phone camera." }) => (
  <div className="relative bg-navy rounded-[2rem] p-6 sm:p-8 text-center text-white w-full max-w-md" data-testid="store-qr-codes">
    <p className="eyebrow !text-teal mb-1">{eyebrow}</p>
    <p className="text-white/70 text-sm">{footer}</p>
    <div className="mt-6 grid grid-cols-2 gap-3 sm:gap-4">
      {CODES.map((c) => (
        <div key={c.id} className="bg-white rounded-2xl p-3 sm:p-4" data-testid={`qr-${c.id}`}>
          <img src={c.src} alt={`Scan to download Generational Health on ${c.store}`} className="w-full aspect-square" />
          <p className="mt-2 font-display text-base sm:text-lg text-navy leading-tight">{c.store}</p>
          <p className="text-xs text-teal font-semibold">{c.device}</p>
        </div>
      ))}
    </div>
  </div>
);
